import { z } from "zod";
import {
  AnimatedImageCustomInput,
  AnimatedImageProviderType,
} from "./animated-image.ts";

export const AnimatedImagePresetDto = z.object({
  externalId: z.string(),
  name: z.string(),
  provider: AnimatedImageProviderType,
  customInput: AnimatedImageCustomInput,
  tags: z.array(z.string()),
  teamExternalId: z.string().nullable(),
  startImageSrc: z.string().nullable(),
  previewVideoSrc: z.string().nullable(),
  endImageSrc: z.string().nullable(),
  animatedImageExternalId: z.string(),
  isFavourite: z.boolean(),
});

export const SetAnimatedImagePresetFavouriteDto = z.object({
  isFavourite: z.boolean(),
});

export const UpdateAnimatedImagePresetDto = z.object({
  name: z.string(),
  provider: AnimatedImageProviderType,
  customInput: AnimatedImageCustomInput,
  tags: z.array(z.string()),
});

export const DeleteAnimatedImagePresetResponseDto = z.object({
  success: z.boolean(),
});

export const PagedAnimatedImagePresetsRequestDto = z.object({
  pageSize: z.number().nullable(),
  cursorCreatedAt: z.string().optional(),
  cursorExternalId: z.string().optional(),
  isFavourite: z.boolean().optional(),
});

export const PagedAnimatedImagePresetsResponseDto = z.object({
  presets: z.array(AnimatedImagePresetDto),
  nextCursor: z
    .object({
      createdAt: z.string(),
      externalId: z.string(),
    })
    .nullable(),
});

export type AnimatedImagePresetDto = z.infer<typeof AnimatedImagePresetDto>;
export type UpdateAnimatedImagePresetDto = z.infer<
  typeof UpdateAnimatedImagePresetDto
>;
export type SetAnimatedImagePresetFavouriteDto = z.infer<
  typeof SetAnimatedImagePresetFavouriteDto
>;
export type DeleteAnimatedImagePresetResponseDto = z.infer<
  typeof DeleteAnimatedImagePresetResponseDto
>;
export type PagedAnimatedImagePresetsRequestDto = z.infer<
  typeof PagedAnimatedImagePresetsRequestDto
>;
export type PagedAnimatedImagePresetsResponseDto = z.infer<
  typeof PagedAnimatedImagePresetsResponseDto
>;
